export enum DialogResponse {
    ok,
    cancel,
    dismiss,
    continue
}
